import { render } from "./AttendanceStats.vue?vue&type=template&id=1f9a1796&scoped=true"
import script from "./AttendanceStats.vue?vue&type=script&lang=js"
export * from "./AttendanceStats.vue?vue&type=script&lang=js"

import "./AttendanceStats.vue?vue&type=style&index=0&id=1f9a1796&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f9a1796"]])

export default __exports__